import _request from 'superagent'

const DEFAULT_TIMEOUT = { response: 15000, deadline: 30000 }

const api = {
  get: (url) => _request.get(url).timeout(DEFAULT_TIMEOUT),
  post: (url) => _request.post(url).timeout(DEFAULT_TIMEOUT),
  put: (url) => _request.put(url).timeout(DEFAULT_TIMEOUT),
  delete: (url) => _request.delete(url).timeout(DEFAULT_TIMEOUT),
  patch: (url) => _request.patch(url).timeout(DEFAULT_TIMEOUT),
}

export default api
